import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import { styled } from '@mui/material'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import { Button } from '../../../../../../../../components/buttons'
import { colorPalette } from '../../../../../../../../style/colorPalette'

type DeletePageConfirmDialogProps = {
  open: boolean
  pageNumber: number
  pageTitle: string
  onConfirm: () => void
  onCancel: () => void
}

export const DeletePageConfirmDialog = ({
  open,
  pageNumber,
  pageTitle,
  onConfirm,
  onCancel,
}: DeletePageConfirmDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth={true}
      PaperProps={{
        style: {
          borderRadius: '12px',
        },
      }}
    >
      <StyledDialogContent>
        <IconWrapper>
          <WarningIcon />
        </IconWrapper>
        <Title>このページを削除しますか？</Title>
        <PageInfo>
          {pageNumber}. {pageTitle}
        </PageInfo>
        <Caution>削除すると元に戻せません。</Caution>
      </StyledDialogContent>
      <StyledDialogActions>
        <Button colorPattern="monotone" variant="outlined" onClick={onCancel}>
          キャンセル
        </Button>
        <Button variant="filled" colorPattern="pink" onClick={onConfirm}>
          削除する
        </Button>
      </StyledDialogActions>
    </Dialog>
  )
}

const StyledDialogContent = styled(DialogContent)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '24px 24px 8px',
  gap: '8px',
})

const IconWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '48px',
  height: '48px',
  borderRadius: '50%',
  backgroundColor: colorPalette.pink[0],
  marginBottom: '4px',
})

const WarningIcon = styled(ErrorOutlineRoundedIcon)({
  color: colorPalette.pink[6],
  fontSize: '28px',
})

const Title = styled('div')({
  fontSize: '15px',
  fontWeight: 'bold',
  color: colorPalette.monotone[10],
  textAlign: 'center',
})

const PageInfo = styled('div')({
  fontSize: '13px',
  fontWeight: 600,
  color: colorPalette.monotone[9],
  textAlign: 'center',
  wordBreak: 'break-all',
})

const Caution = styled('div')({
  fontSize: '12px',
  color: colorPalette.monotone[5],
  textAlign: 'center',
  marginTop: '4px',
})

const StyledDialogActions = styled(DialogActions)({
  padding: '12px 24px 20px',
  gap: '8px',
  justifyContent: 'center',
})
